namespace GeniuzPOS.PosShift {
    export interface ReportRecvbyCashierbyDateForm {
    }

    export class ReportRecvbyCashierbyDateForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.ReportRecvbyCashierbyDate';
    }
}
